<!--  数据加载弹出层
 用法：
 1. 在组件中 import 该组件
 2. 在需要覆盖的父元素下添加该组件
 3. 在父组件中通过 data() 添加状态，控制行为
 4. 在 dataRequest() 方法中，执行请求前将显示状态置为 true，数据返回后（不管成功还是失败），将显示状态置为 false
 -->

<template>
  <div style="height: 100%; width: 100%;">
    <div class="context" v-if="showLoadingBg"></div>
    <div class="loading">
      <img src="../../assets/images/common/loading.gif">
    </div>
  </div>

</template>

<script>
  import $ from 'jquery';
  import {mapState} from 'vuex'

  export default {
    name: 'loading',
    props: ['pWidth', 'pHeight'],
    mounted (){

    },
    data () {
        return {}
    },
    computed: {
      ...mapState({
        showLoadingBg: state => state.isLoadingBg
      })
    }
  }
</script>

<style scoped>
  .loading{
    /*position: absolute;*/
    /*left: 0;*/
    /*top: 0;*/
    /*background: rgba(255, 255, 255, 0.7);*/
    /*min-height: 300px;*/
    /*width: 100%;*/
    /*height: 100%;*/
    /*z-index: 999;*/
    /*overflow: hidden;*/

    width: 45px;
    height:45px;
    position: fixed;
    margin:auto;
    left: 0;
    top:0;
    bottom:0;
    right: 0;
  }

  .loading img {
    /*position: absolute;*/
    width: 45px;
    height: 45px;
    /*left: 50%;*/
    /*margin-left: -128px;*/
    /*top: 50%;*/
    /*margin-top: -128px;*/

  }
  .context{
    width:100%;
    height:100%;
    position: fixed;
    left:0;
    top:0;
    background-color: #333;
    opacity:0.4;
  }
</style>



// WEBPACK FOOTER //
// Loading.vue?70831d0f